import { Box, Typography } from '@mui/material';

import { WIDGET_CHART_HEIGHT } from '#utils/charts.ts';

/**
 * A component that renders an "overlay" when there is no data to display. This
 * was implemented in favor of replicating mui's no data overlay given it's not
 * a public export of the charts package, and the composition approach doesn't
 * support the related prop.
 */
export function EmptyDataOverlay(props: { variant?: 'chart' | 'dialog' }) {
  return (
    <Box
      width="100%"
      minHeight={props.variant === 'chart' ? WIDGET_CHART_HEIGHT : undefined}
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      border={(theme) => `1px dashed ${theme.palette.action.disabled}`}
      borderRadius={1}
    >
      <Typography variant="body1" color="text.secondary">
        No data available
      </Typography>
    </Box>
  );
}
